import axios from "axios";
import { API_URL, securityHeaders } from "../Constants";

import { useMutation, useQuery } from "react-query";

const credentialHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

const login = (values) => {
  return axios.post(API_URL + `/api/Auth/login`, values, {
    // Login must not carry a stale/expired bearer token.
    headers: credentialHeaders,
  });
};

export const useLogin = () => {
  return useMutation(login);
};

const forgotPassword = (email) => {
  return axios.post(API_URL + `/api/Auth/forgotPassword`, email, {
    headers: credentialHeaders,
  });
};

export const useForgotPassword = () => {
  return useMutation(forgotPassword);
};

const fetchCouncilTeams = async () => {
  return await axios.get(API_URL + "/api/RolePage/ValidateToken", {
    headers: securityHeaders,
  });
};

export const useValidate = () => {
  return useQuery({
    queryKey: ["validation"],
    queryFn: () => fetchCouncilTeams(),
    enabled: true,
    refetchOnWindowFocus: false,
    onError: (e) => {
      return e;
    },
  });
};
